var React = require('react');

function FrontierNewInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"FD_LOGO","data-name":"FD LOGO"},React.createElement("path",{"className":"cls-1","d":"M183.22,37.39,0,208.22V170.84L183.22,0ZM0,239.92V326.5H29.88v-77L131.25,155V117.55ZM155.8,97.64V301.05H84.94V272.51l46.35-43.28V191.86l-76.18,71v63.38h128V72.14Z"})))]);
}

FrontierNewInline.defaultProps = {"viewBox":"0 0 183.22 326.5"};

module.exports = FrontierNewInline;

FrontierNewInline.default = FrontierNewInline;
